import React from "react";
import { translate } from '@td/shared_utils';
import {
  Modal,
  ModalTitle,
  ModalDescription
} from "@td/ui";

import { useRuleSettings } from "../contexts/rule-settings-context";
import RuleSettingsForm from 'app/states-services/physician-supervision-rules/components/rule-settings-form';
import styles from './styles.module.scss';

const RuleSettingsModal = () => {
  const { modalIsOpen, setModalIsOpen } = useRuleSettings();

  const modalTitle = translate(null, "state_chart_review.config_form.modal.title");
  return (
    <Modal
      isOpen={modalIsOpen}
      onClose={() => { setModalIsOpen(false) }}
      title={modalTitle}
      className={styles.ruleSettingsModal}
    >
      <ModalTitle
        title={modalTitle}
      />
      <ModalDescription
        className={styles.formDescription}
        description={translate(null, "state_chart_review.config_form.modal.description")}
      />
      <RuleSettingsForm />
    </Modal>
  );
};

RuleSettingsModal.propTypes = {};

export default RuleSettingsModal;
